'use client';

import { useState } from 'react';
import Link from 'next/link';
import { MenuItem as MenuItemT } from '@/utils/drupal-api/__generated__/graphql';
import clsx from 'clsx';

const MenuGroup: React.FC<{ items: MenuItemT[]; drawer?: boolean }> = ({
  items,
  drawer,
}) => {
  const drawerStyle = drawer
    ? 'lg:flex'
    : `menu:flex menu:flex-row menu:justify-between`;
  return (
    <div
      className={clsx(
        `flex w-full flex-col divide-y lg:divide-y-0`,
        items.length > 4 && 'menu:flex-wrap',
        drawerStyle
      )}
    >
      {items.map((item, i) => (
        <MenuItem
          last={i + 1 === items.length}
          drawer={drawer}
          key={item.url}
          item={item as MenuItemT}
        />
      ))}
    </div>
  );
};

const MenuItem: React.FC<{
  item: MenuItemT;
  drawer?: boolean;
  last?: boolean;
}> = ({ item, drawer, last }) => {
  const [isOpen, setIsOpen] = useState(false);
  const drawerStyle = drawer ? 'w-full' : ``;
  return (
    <div className={clsx('relative flex flex-col py-[1rem]', drawerStyle)}>
      <div
        onClick={() => {
          setIsOpen((prev) => !prev);
        }}
        className="relative flex w-full flex-row items-center justify-between lg:w-fit"
      >
        <Link
          onClick={(e) => {
            e.stopPropagation();
          }}
          href={item.url || ''}
          className="mr-[1rem] w-fit justify-between whitespace-nowrap text-primary-main"
        >
          <h6 className="truncate text-primary-main">{item.title}</h6>
        </Link>
        <div
          className="z-10 flex h-full grow items-center justify-end p-[1rem]"
          // style="text"
          onClick={(e) => {
            e.stopPropagation();
            setIsOpen((prev) => !prev);
          }}
        >
          {item.children.length !== 0 && (
            <svg
              className={clsx(isOpen && 'rotate-180', 'menu:hidden')}
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="12"
              viewBox="0 0 18 12"
              fill="none"
            >
              <path
                d="M2 2.5L9 9.5L16 2.5"
                stroke="#BEBEBE"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          )}
        </div>
      </div>
      {item.children.length > 0 && isOpen && (
        <ul
          className={clsx(
            last && 'right-0',
            'menu:absolute menu:mt-[2rem] menu:divide-y bg-white'
          )}
        >
          {item.children.map((child) => (
            <li className="py-[0.25rem]" key={child.url}>
              <Link
                href={child.url || ''}
                target={child.attributes?.target || ''}
                className={clsx(
                  'ut-sm menu:whitespace-nowrap text-black-1 !no-underline hover:text-secondary-main',
                  child.attributes?.class || ''
                )}
              >
                {child.title}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MenuGroup;
